import StaticLocation from './StaticLocation';

export default StaticLocation;
